import { put, call, takeLatest, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myQaQuestionListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/myQaQuestionListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MY_QA_QUESTION_LIST_SET",
        payload: {
          list: res.data.list,
          count: res.data.count,
      		countOpen: res.data.countOpen,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myQaQuestionItemGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('qaId', payload.qaId);
    return axios.post(config.apiUri + "member/myQaQuestionItemApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myQaQuestionSave(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'save');
    params.append('qaId', payload.qaId);
    params.append('qaDate', payload.qaDate);
    params.append('qaQuestion', payload.qaQuestion);
    payload.qaAnswer.map( (value, index) => params.append('qaAnswer[]', value) );
    params.append('qaListOpen', payload.qaListOpen);
    params.append('check', payload.check);
    return axios.post(config.apiUri + "member/myQaQuestionEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield delay(500);
      yield put({
        type: "MY_QA_QUESTION_LIST_INIT"
      });

      yield put({ type:'SNACK_SET', payload:{visible:true, severity:'success', duration:5000, comment:(action.payload.check === 3) ? '保存しました': '申請しました'}});
      action.callback(res.data.qaId);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myQaQuestionItemDel(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('qaId', payload.qaId);
    return axios.post(config.apiUri + "member/myQaQuestionEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield delay(500);
      yield put({
        type: 'MY_QA_QUESTION_LIST_GET',
    		payload: {
    			page: state.my.qaQuestion.page,
    		},
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myQaQuestionStatisticsGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('qaId', payload.qaId);
    return axios.post(config.apiUri + "member/myQaQuestionStatisticsApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "MY_QA_QUESTION_STATISTICS_SET",
        payload: {
          type: 'add',
          qaId: action.payload.qaId,
          list: res.data.list,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myQaQuestionStatisticsUserGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('qaId', payload.qaId);
    params.append('answerText', payload.answerText);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/myQaQuestionStatisticsUserApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MY_QA_QUESTION_LIST_GET', myQaQuestionListGet),
  takeLatest('MY_QA_QUESTION_ITEM_GET', myQaQuestionItemGet),
  takeLatest('MY_QA_QUESTION_SAVE', myQaQuestionSave),
  takeLatest('MY_QA_QUESTION_ITEM_DEL', myQaQuestionItemDel),
  takeLatest('MY_QA_QUESTION_STATISTICS_GET', myQaQuestionStatisticsGet),
  takeLatest('MY_QA_QUESTION_STATISTICS_USER_GET', myQaQuestionStatisticsUserGet),
];

export default saga;
